import { WorkflowStepCode } from '@exam-management/graphql';
import { Flex, PaperSection } from '@shared/components';

import { useQuestionCreationTaskDetails } from '../../providers';
import { ItemSetQuestionListTable } from '../item-set-question-list-table';
import { QuestionCreationMenuButton } from '../question-creation-menu-button';
import { QuestionCreationTaskStartSection } from '../question-creation-task-start-section';
import { SingleQuestionList } from '../single-question-list';

export default function QuestionListSection() {
  const { task, status } = useQuestionCreationTaskDetails();

  const singleQuestionCount = task.metadata?.requirement?.requiredQuestionCount ?? 0;
  const itemSetQuestionCount = task.metadata?.requirement?.itemSetCondition
    ? task.metadata.requirement.itemSetCondition.length
    : 0;
  return (
    <PaperSection
      title='Question List'
      sx={{ flex: 1 }}
      endAdornment={<QuestionCreationMenuButton />}
    >
      <Flex
        sx={{
          flexDirection: 'column',
          flex: 1,
          gap: (theme) => theme.spacing(6),
          p: (theme) => theme.spacing(6),
        }}
      >
        <QuestionCreationTaskStartSection />
        {singleQuestionCount > 0 && status.code !== WorkflowStepCode.QuestionCreationTodo ? (
          <SingleQuestionList />
        ) : null}

        {itemSetQuestionCount > 0 && status.code !== WorkflowStepCode.QuestionCreationTodo ? (
          <ItemSetQuestionListTable />
        ) : null}
      </Flex>
    </PaperSection>
  );
}
